"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlatform = void 0;
function getPlatform() {
    var window = window || undefined;
    return window !== undefined ? "browser" : "node";
}
exports.getPlatform = getPlatform;
//# sourceMappingURL=platform.js.map